var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.articleId)?_c('article-files',{staticClass:"flex-grow-1 mt-3",attrs:{"scope":_vm.scope,"article-id":_vm.articleId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }